module.exports = __webpack_public_path__ + "img/be-box.1bd31c6e.png";